import { Location } from '@angular/common'
import { Directive, HostListener, Input, inject } from '@angular/core'
import { Router } from '@angular/router'
import { firstValueFrom } from 'rxjs'
import { RouterFacadeService } from '@wm-front/core'

@Directive({
  selector: '[wmFrontBackButton]',
  standalone: true,
})
export class BackButtonDirective {
  /** Default route when there is no navigation history */
  @Input() public defaultRoute: string

  protected _router = inject(Router)

  protected _routerFacadeService = inject(RouterFacadeService)

  protected _location = inject(Location)

  /** Goes back to the previous view */
  @HostListener('click')
  public async back(): Promise<void> {
    const routerState = await firstValueFrom(this._routerFacadeService.data$)

    if (routerState.navigationId === 1) {
      await this._router.navigate([this.defaultRoute])
    } else {
      this._location.back()
    }
  }
}
